<template>
  <section class="container">
    <h1>Edit Grape</h1>
    <GrapeForm formType="edit-direct" :editGrapeID="this.$route.params.grapeID" />
  </section>

</template>

<script>
  import GrapeForm from './GrapeForm.vue'

  export default {
    name: 'edit-grape',
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
    },
    mounted () {
    },
    components: {
      GrapeForm
    }
  };
</script>

<style scoped>

  section {
    height: 100vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/EditGrape.vue